import { action } from '@ember/object';
import { runTask } from 'ember-lifeline';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinReturnsComponent extends Component {
  @service organisation;

  get returns() {
    return this.args.returns;
  }

  get calculations() {
    return (this.returns?.calculations || []).map((calculation) => {
      return {
        ...calculation,
        type: calculation.type.toLowerCase().replaceAll('_', '-'),
      };
    });
  }

  get showTotal() {
    return this.calculations.filter((item) => item.confidence_value).length > 0;
  }

  @action
  addReturn(type, status) {
    const returns = this.returns
      ? { ...this.returns }
      : { value: 0, calculations: [] };
    returns.calculations.push({
      type,
      status,
      confidence_label: 'Medium',
      confidence_value: this.organisation.bon_return_confidences['medium'],
      notes: {},
    });
    this.args.updateBonReturns(returns);
  }

  @action
  deleteReturnAtIndex(index) {
    const returns = { ...this.returns };
    returns.calculations.splice(index, 1);
    this.args.updateBonReturns(returns);
  }

  @action
  onValueEmit(index, calculation) {
    const returns = { ...this.returns };
    returns.calculations[index] = calculation;
    this.args.updateBonReturns(returns);
    runTask(this, () => this.args.checkForIncompleteTemplates());
  }

  @action
  onSlideoverToggle(key, type = null) {
    const joinedKey =
      type && typeof type === 'string' ? `${key}-${type}`.toLowerCase() : key;
    switch (joinedKey) {
      case 'upsell-value':
        this.args.toggleUpsellValueSlideover();
        break;

      case 'confidence-return':
        this.args.toggleReturnConfidenceSlideover();
        break;

      case 'fte':
        this.args.toggleFteSlideover();
        break;

      case 'clv':
        this.args.toggleClvSlideover();
        break;

      case 'customer-values':
        this.args.toggleCustomerValuesSlideover();
        break;
    }
  }

  @action
  handleAddFirstReturn(type, status) {
    this.addReturn(type, status);
    if (!this.args.editMode) this.args.toggleEditMode();
  }

  @action
  resetUnsavedChanges() {
    this.args?.resetBon?.();
  }

  @action
  handleAddCalculation(type, status) {
    this.args.toggleEditMode(true);
    this.addReturn(type, status);
  }
}
